import { render, staticRenderFns } from "./shipping-policy.vue?vue&type=template&id=08c7cff3&scoped=true&"
import script from "./shipping-policy.vue?vue&type=script&lang=js&"
export * from "./shipping-policy.vue?vue&type=script&lang=js&"
import style0 from "./shipping-policy.vue?vue&type=style&index=0&id=08c7cff3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c7cff3",
  null
  
)

export default component.exports